import React, { useCallback } from 'react';
import { Anchor, Inscription, WarningCard, WarningIcon } from '@common-fe/common-fe';

import { LockboxSource } from '@/modules/employer/components/Lockbox/lockbox.types';
import useLockboxDetailsStore from '@/modules/employer/components/Lockbox/LockboxDetails/stores/useLockboxDetails.store';

const MultipleRequestsDetectedWarningMessage = () => {
  const { setIsDividingMode, originalLockbox } = useLockboxDetailsStore();
  const isDocufree = originalLockbox?.source === LockboxSource.DOCUFREE;

  const handleSetDiviningMode = useCallback(() => {
    setIsDividingMode(true);
  }, [setIsDividingMode]);

  if (isDocufree) return null;
    
  return (
    <WarningCard
      testId="multiple-requests-detected"
      icon={<WarningIcon color="warning" />}
      backgroundColor="warningContainer"
      borderColor="warningBorder"
      topBorderColor="transparent"
      title={(
        <Inscription color="textBody" weight={700}>
          Multiple requests detected. Enter{' '}
          <Anchor
            onClick={handleSetDiviningMode}
            weight={700}
          >
            Dividing Mode
          </Anchor> to separate records.
        </Inscription>
      )}
      containerProps={{ pad: 'spacing24' }}
      border={false}
    />
  );
};

export default MultipleRequestsDetectedWarningMessage;
